import { defineComponent as a, openBlock as r, createElementBlock as o, normalizeClass as m, unref as s, renderSlot as t } from "vue";
import { useNamespace as l } from "./index559.js";
var u = /* @__PURE__ */ a({
  name: "ElMain",
  __name: "main",
  setup(c) {
    const e = l("main");
    return (n, i) => (r(), o(
      "main",
      {
        class: m(s(e).b())
      },
      [
        t(n.$slots, "default")
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  u as default
};
